// Mock data for Campaign Calls

export const callStatuses = {
  queued: { labelKey: 'callStatuses.queued', color: 'bg-gray-100 text-gray-600' },
  calling: { labelKey: 'callStatuses.calling', color: 'bg-blue-100 text-blue-700', pulse: true },
  connected: { labelKey: 'callStatuses.connected', color: 'bg-green-100 text-green-700', pulse: true },
  completed: { labelKey: 'callStatuses.completed', color: 'bg-purple-100 text-purple-700' },
  no_answer: { labelKey: 'callStatuses.no_answer', color: 'bg-yellow-100 text-yellow-700' },
  voicemail: { labelKey: 'callStatuses.voicemail', color: 'bg-orange-100 text-orange-700' },
  failed: { labelKey: 'callStatuses.failed', color: 'bg-red-100 text-red-700' },
  busy: { labelKey: 'callStatuses.busy', color: 'bg-yellow-100 text-yellow-700' },
  // crm_dial_whitelist pilot gate (#1287): a REAL lead that was NEVER dialed
  // because its number is not on the test whitelist. Neutral badge — it is NOT
  // "Completada" and NOT "Sin respuesta"; without this entry the row fell back to
  // callStatuses.completed and lied that the lead had been called
  // (fix-campaign-skipped-pilot-labels-sep3).
  skipped_pilot: { labelKey: 'callStatuses.skipped_pilot', color: 'bg-gray-100 text-gray-600' },
  // PROVIDER rejection at Twilio calls.create (e.g. suspended account HTTP 401
  // "status 4 is not active"). Backend marks the contact TERMINAL 'provider_error'
  // with a human skip_reason (PR #1590, mark_contact_provider_error). Without this
  // entry the row fell back to callStatuses.completed and showed a green/purple
  // "Completada" badge — silently lying that the lead had been called, the exact
  // failure the skipped_pilot fix above cured. Red badge: the dial did NOT connect.
  // (postventa-provider-error-ui-badge-sep20-0345)
  provider_error: { labelKey: 'callStatuses.provider_error', color: 'bg-red-100 text-red-700' },
  // Twilio raw statuses (display layer only — never change stored values)
  initiated:     { labelKey: 'callStatuses.initiated',   color: 'bg-blue-100 text-blue-700' },
  ringing:       { labelKey: 'callStatuses.ringing',     color: 'bg-blue-100 text-blue-700', pulse: true },
  answered:      { labelKey: 'callStatuses.answered',    color: 'bg-green-100 text-green-700' },
  'in-progress': { labelKey: 'callStatuses.in_progress', color: 'bg-green-100 text-green-700', pulse: true },
  canceled:      { labelKey: 'callStatuses.canceled',    color: 'bg-gray-100 text-gray-600' },
  'no-answer':   { labelKey: 'callStatuses.no_answer',   color: 'bg-yellow-100 text-yellow-700' }, // Twilio hyphen alias
  ended:         { labelKey: 'callStatuses.completed',   color: 'bg-purple-100 text-purple-700' }, // web call ended state
};

export const callOutcomes = {
  payment_promise: { labelKey: 'callOutcomes.payment_promise', color: 'bg-green-100 text-green-700' },
  partial_payment: { labelKey: 'callOutcomes.partial_payment', color: 'bg-emerald-100 text-emerald-700' },
  paid: { labelKey: 'callOutcomes.paid', color: 'bg-green-200 text-green-800' },
  callback_scheduled: { labelKey: 'callOutcomes.callback_scheduled', color: 'bg-blue-100 text-blue-700' },
  refused: { labelKey: 'callOutcomes.refused', color: 'bg-red-100 text-red-700' },
  refused_to_pay: { labelKey: 'callOutcomes.refused_to_pay', color: 'bg-red-100 text-red-600' },
  wrong_number: { labelKey: 'callOutcomes.wrong_number', color: 'bg-gray-100 text-gray-700' },
  not_interested: { labelKey: 'callOutcomes.not_interested', color: 'bg-orange-100 text-orange-700' },
  info_updated: { labelKey: 'callOutcomes.info_updated', color: 'bg-cyan-100 text-cyan-700' },
  dispute: { labelKey: 'callOutcomes.dispute', color: 'bg-amber-100 text-amber-700' },
  disputed: { labelKey: 'callOutcomes.disputed', color: 'bg-amber-100 text-amber-700' },
  hung_up: { labelKey: 'callOutcomes.hung_up', color: 'bg-gray-100 text-gray-600' },
  voicemail: { labelKey: 'callOutcomes.voicemail', color: 'bg-orange-100 text-orange-600' },
  no_answer: { labelKey: 'callOutcomes.no_answer', color: 'bg-yellow-100 text-yellow-700' },
  third_party: { labelKey: 'callOutcomes.third_party', color: 'bg-purple-100 text-purple-700' },
  deceased: { labelKey: 'callOutcomes.deceased', color: 'bg-gray-200 text-gray-700' },
  negotiation_in_progress: { labelKey: 'callOutcomes.negotiation_in_progress', color: 'bg-indigo-100 text-indigo-700' },
  // Sales (automotive) outcomes
  appointment_scheduled: { labelKey: 'callOutcomes.appointment_scheduled', color: 'bg-green-100 text-green-700' },
  interested: { labelKey: 'callOutcomes.interested', color: 'bg-blue-100 text-blue-700' },
  test_drive_scheduled: { labelKey: 'callOutcomes.test_drive_scheduled', color: 'bg-emerald-100 text-emerald-700' },
  // Legacy tool enum values
  promise: { labelKey: 'callOutcomes.payment_promise', color: 'bg-green-100 text-green-700' },
  callback: { labelKey: 'callOutcomes.callback_scheduled', color: 'bg-blue-100 text-blue-700' },
  resolved: { labelKey: 'callOutcomes.resolved', color: 'bg-green-100 text-green-700' },
  escalation: { labelKey: 'callOutcomes.escalation', color: 'bg-red-100 text-red-700' },
  // Missing backend outcomes
  cannot_pay:        { labelKey: 'callOutcomes.cannot_pay',        color: 'bg-red-100 text-red-600' },
  insufficient_data: { labelKey: 'callOutcomes.insufficient_data', color: 'bg-gray-100 text-gray-500' },
  no_contact: { labelKey: 'callOutcomes.no_answer', color: 'bg-yellow-100 text-yellow-700' },
  no_response: { labelKey: 'callOutcomes.no_response', color: 'bg-orange-100 text-orange-700' },
  other: { labelKey: 'callOutcomes.other', color: 'bg-gray-100 text-gray-600' },
  no_outcome: { labelKey: 'callOutcomes.no_outcome', color: 'bg-gray-100 text-gray-500' },
};

// Generate mock calls for a campaign
export const generateMockCalls = (campaignId, count = 20) => {
  const calls = [];
  const statuses = ['completed', 'completed', 'completed', 'voicemail', 'no_answer', 'failed'];
  const outcomes = ['payment_promise', 'callback_scheduled', 'refused', 'not_interested', 'hung_up', 'info_updated'];

  const baseTime = new Date();
  baseTime.setHours(baseTime.getHours() - 2);

  for (let i = 0; i < count; i++) {
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const duration = status === 'completed' ? Math.floor(Math.random() * 300) + 60 :
                    status === 'voicemail' ? Math.floor(Math.random() * 30) + 15 : 0;

    const startTime = new Date(baseTime.getTime() + (i * 180000)); // 3 min apart
    const endTime = new Date(startTime.getTime() + (duration * 1000));

    calls.push({
      id: `call_${campaignId}_${String(i + 1).padStart(3, '0')}`,
      campaignId,
      phone: maskPhoneNumber(`+1555${String(Math.floor(Math.random() * 9000000) + 1000000)}`),
      phoneRaw: `+1555${String(Math.floor(Math.random() * 9000000) + 1000000)}`,
      status,
      outcome: status === 'completed' ? outcomes[Math.floor(Math.random() * outcomes.length)] : null,
      duration,
      attempts: Math.floor(Math.random() * 3) + 1,
      startedAt: startTime.toISOString(),
      endedAt: duration > 0 ? endTime.toISOString() : null,
      twilioSid: `CA${generateRandomString(32)}`,
    });
  }

  return calls.reverse(); // Most recent first
};

// Mask phone number for privacy
export const maskPhoneNumber = (phone) => {
  if (!phone) return '';
  // +1 555 123 4567 -> +1 (555) ***-**67
  const digits = phone.replace(/\D/g, '');
  if (digits.length >= 10) {
    const last2 = digits.slice(-2);
    return `+1 (${digits.slice(-10, -7)}) ***-**${last2}`;
  }
  return phone;
};

// Generate random string for IDs
const generateRandomString = (length) => {
  const chars = 'abcdef0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

// Format duration in seconds to mm:ss
export const formatDuration = (seconds) => {
  if (!seconds || seconds === 0) return '-';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${String(secs).padStart(2, '0')}`;
};

// Format timestamp to time only
export const formatTime = (isoString) => {
  if (!isoString) return '-';
  const date = new Date(isoString);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
};

// Format timestamp to relative time
export const formatRelativeTime = (isoString) => {
  if (!isoString) return '-';
  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  return date.toLocaleDateString();
};

// Pre-generated calls for campaign 001 (running campaign)
export const mockCallsCamp001 = generateMockCalls('camp_001', 25);

// Generate a single new mock call (for realtime simulation)
export const generateNewMockCall = (campaignId) => {
  const statuses = ['completed', 'completed', 'voicemail', 'no_answer'];
  const outcomes = ['payment_promise', 'callback_scheduled', 'refused', 'not_interested'];
  const status = statuses[Math.floor(Math.random() * statuses.length)];
  const duration = status === 'completed' ? Math.floor(Math.random() * 240) + 60 :
                  status === 'voicemail' ? Math.floor(Math.random() * 25) + 10 : 0;

  const now = new Date();
  const startTime = new Date(now.getTime() - (duration * 1000));

  return {
    id: `call_${campaignId}_${Date.now()}`,
    campaignId,
    phone: maskPhoneNumber(`+1555${String(Math.floor(Math.random() * 9000000) + 1000000)}`),
    status,
    outcome: status === 'completed' ? outcomes[Math.floor(Math.random() * outcomes.length)] : null,
    duration,
    attempts: 1,
    startedAt: startTime.toISOString(),
    endedAt: now.toISOString(),
    twilioSid: `CA${generateRandomString(32)}`,
  };
};
